module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('div', {
    staticClass: "col-md-12 text-right mb-4 px-0"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": !_vm.hasUnsavedChanges
    },
    on: {
      "click": _vm.save
    }
  })]), _vm._v(" "), (_vm.accordions[0].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(0)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Check-in")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[0].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[0].isOpen && _vm.accordions[0].enabled) ? _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-4 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Location to check-in\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.location.name),
      expression: "localPresets.location.name"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localPresets.location.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets.location, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Latitude\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.location.latitude),
      expression: "localPresets.location.latitude"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localPresets.location.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets.location, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Longitude\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.location.longitude),
      expression: "localPresets.location.longitude"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localPresets.location.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets.location, "longitude", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[1].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(1)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Agent Sales - Payment and Deposit")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[1].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[1].isOpen && _vm.accordions[1].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Payment\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getRequirePaymentOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setAgentPaymentDepositType
    },
    model: {
      value: (_vm.agentsPaymentDepositType),
      callback: function($$v) {
        _vm.agentsPaymentDepositType = $$v
      },
      expression: "agentsPaymentDepositType"
    }
  })], 1), _vm._v(" "), (_vm.localPresets.agentsPaymentDepositType && _vm.localPresets.agentsPaymentDepositType == 2) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Deposit\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getDepositOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setAgentDepositType
    },
    model: {
      value: (_vm.agentsDepositType),
      callback: function($$v) {
        _vm.agentsDepositType = $$v
      },
      expression: "agentsDepositType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fs-smaller dark"
  }, [_vm._v("This is the deposit that the customer must pay at the time of booking.")])], 1) : _vm._e(), _vm._v(" "), (_vm.localPresets.agentsPaymentDepositType && _vm.localPresets.agentsPaymentDepositType == 2 && _vm.agentsDepositType && _vm.agentsDepositType.id != 2) ? _c('div', {
    staticClass: "col-md-2 mb-2 d-flex justify-content-end"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Amount\n                        "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localPresets.agentsDepositValue),
      expression: "localPresets.agentsDepositValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.agentsDepositValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "agentsDepositValue", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.localPresets.agentsDepositType == 0) ? _c('div', {
    staticClass: "glued-left glued-left-min-width"
  }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.localPresets.agentsDepositType == 1) ? _c('div', {
    staticClass: "glued-left glued-left-min-width"
  }, [_vm._v("%")]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.accordions[2].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(2)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Direct Sales - Payment and Deposit")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[2].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[2].isOpen && _vm.accordions[2].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Payment\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getRequirePaymentOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setPaymentDepositType
    },
    model: {
      value: (_vm.paymentDepositType),
      callback: function($$v) {
        _vm.paymentDepositType = $$v
      },
      expression: "paymentDepositType"
    }
  })], 1), _vm._v(" "), (_vm.localPresets.paymentDepositType && _vm.localPresets.paymentDepositType == 2) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Deposit\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getDepositOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setDepositType
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fs-smaller dark"
  }, [_vm._v("This is the deposit that the customer must pay at the time of booking.")])], 1) : _vm._e(), _vm._v(" "), (_vm.localPresets.paymentDepositType && _vm.localPresets.paymentDepositType == 2 && _vm.depositType && _vm.depositType.id != 2) ? _c('div', {
    staticClass: "col-md-2 mb-2 d-flex justify-content-end"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Amount\n                        "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localPresets.depositValue),
      expression: "localPresets.depositValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.depositValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "depositValue", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.localPresets.depositType == 0) ? _c('div', {
    staticClass: "glued-left glued-left-min-width"
  }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.localPresets.depositType == 1) ? _c('div', {
    staticClass: "glued-left glued-left-min-width"
  }, [_vm._v("%")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Default cancel payment type\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.paymentCancelTypeOptions,
      "label": "name"
    },
    on: {
      "input": _vm.setPaymentCancelType
    },
    model: {
      value: (_vm.paymentCancelTypeObject),
      callback: function($$v) {
        _vm.paymentCancelTypeObject = $$v
      },
      expression: "paymentCancelTypeObject"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.accordions[3].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(3)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Cancellation rules")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[3].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[3].isOpen && _vm.accordions[3].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Direct - In person")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.accordions[4].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(4)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Commissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[4].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[4].isOpen && _vm.accordions[4].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row px-5 mb-3 align-items-start"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-12 darkest font-weight-600"
  }, [_vm._v("Agents")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Products - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionAgentsProduct),
      expression: "localPresets.commissionAgentsProduct"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionAgentsProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionAgentsProduct", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Extras - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionAgentsComponent),
      expression: "localPresets.commissionAgentsComponent"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionAgentsComponent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionAgentsComponent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Pickups - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionAgentsTransport),
      expression: "localPresets.commissionAgentsTransport"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionAgentsTransport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionAgentsTransport", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-12 darkest font-weight-600"
  }, [_vm._v("My Team - Sellers")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Products - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionMyTeamProduct),
      expression: "localPresets.commissionMyTeamProduct"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionMyTeamProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionMyTeamProduct", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Extras - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionMyTeamComponent),
      expression: "localPresets.commissionMyTeamComponent"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionMyTeamComponent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionMyTeamComponent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                            Pickups - Commission by default\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPresets.commissionMyTeamTransport),
      expression: "localPresets.commissionMyTeamTransport"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.commissionMyTeamTransport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "commissionMyTeamTransport", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[5].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(5)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Discounts")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[5].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[5].isOpen && _vm.accordions[5].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Exclude extras from discounts\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.excludeExtraFromDiscounts),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "excludeExtraFromDiscounts", $$v)
      },
      expression: "localPresets.excludeExtraFromDiscounts"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[6].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(6)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Agents Permissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[6].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[6].isOpen && _vm.accordions[6].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Agents have access to Extras\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.agentsHaveAccessExtras),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "agentsHaveAccessExtras", $$v)
      },
      expression: "localPresets.agentsHaveAccessExtras"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Agents have access to Pickups\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.agentsHaveAccessPickups),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "agentsHaveAccessPickups", $$v)
      },
      expression: "localPresets.agentsHaveAccessPickups"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[7].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(7)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Widget Permissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[7].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[7].isOpen && _vm.accordions[7].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Widget have access to Extras\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.widgetHaveAccessExtras),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "widgetHaveAccessExtras", $$v)
      },
      expression: "localPresets.widgetHaveAccessExtras"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Widget have access to Pickups\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.widgetHaveAccessPickups),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "widgetHaveAccessPickups", $$v)
      },
      expression: "localPresets.widgetHaveAccessPickups"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[8].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(8)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Sales")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[8].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[8].isOpen && _vm.accordions[8].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex align-items-center ml-3 w-100"
  }, [_c('label', {
    staticClass: "full darkest"
  }, [_vm._v("\n                        Charge total amount for product higher than  \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localPresets.chargeTotalAmount),
      expression: "localPresets.chargeTotalAmount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right bg-lighter",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localPresets.chargeTotalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localPresets, "chargeTotalAmount", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark"
  }, [_vm._v("€")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 d-flex ljustify-content-end"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Allow refund without code\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.allowRefundWithoutCode),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "allowRefundWithoutCode", $$v)
      },
      expression: "localPresets.allowRefundWithoutCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Price Rounding Behavior (configuration option for price adjustments):\n                ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "value": _vm.roundingBehaviorInit,
      "options": _vm.roundingBehaviourTypeOptions,
      "label": "name"
    },
    on: {
      "input": function($event) {
        return _vm.roundingBehaviorUpdateVal($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.accordions[9].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(9)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Payment Link")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[9].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[9].isOpen && _vm.accordions[9].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Receive a notification when the customer completes the payment\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.emailSettings.allowPaymentLink),
      callback: function($$v) {
        _vm.$set(_vm.localPresets.emailSettings, "allowPaymentLink", $$v)
      },
      expression: "localPresets.emailSettings.allowPaymentLink"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[10].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(10)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Automatic emails")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[10].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[10].isOpen && _vm.accordions[10].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.emailSettings.allowPreEvent),
      callback: function($$v) {
        _vm.$set(_vm.localPresets.emailSettings, "allowPreEvent", $$v)
      },
      expression: "localPresets.emailSettings.allowPreEvent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.emailSettings.allowPostEvent),
      callback: function($$v) {
        _vm.$set(_vm.localPresets.emailSettings, "allowPostEvent", $$v)
      },
      expression: "localPresets.emailSettings.allowPostEvent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 my-2 align-items-center w-100"
  }, [_c('button', {
    staticClass: "btn wide ml-3",
    on: {
      "click": _vm.sendTestEmail
    }
  }, [_vm._v("Send Test Email")])])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[11].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(11)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Segmentation")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[11].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[11].isOpen && _vm.accordions[11].enabled) ? _c('div', {
    staticClass: "col-md-7 row mb-4"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n\t\t\t\t\tOrigins are required in reservations\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.isOriginRequired),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "isOriginRequired", $$v)
      },
      expression: "localPresets.isOriginRequired"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n\t\t\t\t\tSegments are required in reservations\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localPresets.isSegmentRequired),
      callback: function($$v) {
        _vm.$set(_vm.localPresets, "isSegmentRequired", $$v)
      },
      expression: "localPresets.isSegmentRequired"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [(_vm.accordions[12].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(12)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Cancellation Reasons")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[12].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[12].isOpen && _vm.accordions[12].enabled) ? _c('div', {
    staticClass: "col-md-12 row mb-4"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {}, [_c('div', {
    staticClass: "my-4 initial-height"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tHere you can define Cancellation Reasons so you can choose them when canceling reservations or events.\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.getReasons.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNo items available\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-12 pl-0"
  }, [(_vm.getReasons.length > 0) ? _c('div', _vm._l((_vm.groupedReasons), function(reasons, reasonType) {
    return _c('div', {
      key: reasonType
    }, [_c('div', {
      staticClass: "my-2"
    }, [_vm._v(_vm._s(_vm.reasonGroupName(reasonType)))]), _vm._v(" "), _c('div', {
      staticClass: "custom-fields mb-5"
    }, _vm._l((reasons), function(reason) {
      return _c('div', {
        key: reason.id
      }, [_c('div', {
        staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
      }, [_c('div', {
        staticClass: "darker bold"
      }, [_vm._v(_vm._s(reason.description))]), _vm._v(" "), _c('div', {
        staticClass: "withHover"
      }, [_c('span', {
        staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
        on: {
          "click": function($event) {
            return _vm.editReason(reason)
          }
        }
      }, [_vm._v("Edit")]), _vm._v(" "), _c('i', {
        staticClass: "ico ico-delete fs-normal dark pointer ml-2",
        on: {
          "click": function($event) {
            return _vm.clickTrashReason(reason)
          }
        }
      })])])])
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("Add Cancellation Reason")])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [(_vm.accordions[13].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(13)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Custom Business Types")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[13].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[13].isOpen && _vm.accordions[13].enabled) ? _c('div', {
    staticClass: "col-md-12 row mb-4"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "my-4 initial-height"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tHere you can define your custom business types.\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.getCustomBusinessTypes.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNo items available\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-12 pl-0"
  }, [(_vm.getCustomBusinessTypes.length > 0) ? _c('div', {
    staticClass: "my-2"
  }, [_vm._v("All")]) : _vm._e(), _vm._v(" "), (_vm.getCustomBusinessTypes.length > 0) ? _c('div', {
    staticClass: "custom-fields mb-5"
  }, _vm._l((_vm.getCustomBusinessTypes), function(customBusinessType) {
    return _c('div', {
      key: customBusinessType.id
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
    }, [_c('div', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(customBusinessType.name))]), _vm._v(" "), _c('div', {
      staticClass: "withHover"
    }, [_c('span', {
      staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
      on: {
        "click": function($event) {
          return _vm.editCustomBusinessType(customBusinessType)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete fs-normal dark pointer ml-2",
      on: {
        "click": function($event) {
          return _vm.clickTrashCustomBusinessType(customBusinessType)
        }
      }
    })])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.addCustomBusinessType
    }
  }, [_vm._v("Add Custom Business Type")])])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-5 mt-4"
  }, [_c('div', {
    staticClass: "col-md-12 darker font-weight-600"
  }, [_vm._v("Time before event for automatic cancellation:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-0 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 dark font-weight-600 fs-small text-center"
  }, [_vm._v("\n                            Commission\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-0 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 dark font-weight-600 fs-small text-center"
  }, [_vm._v("\n                            Commission\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reminder email: ")]), _vm._v("Send an email 24 hours before the experience.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Follow-Up Email: ")]), _vm._v("Send an email 4 hours after the experience.\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a67c4f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabPresets.vue
// module id = 2212
// module chunks = 0